// Google Calendar connect: the integration service sends the browser back to our
// return page with ?connect_ticket=<sealed ticket>. Nothing is saved until our
// backend hands that ticket back as the signed-in user.

const PARAM = 'connect_ticket';

/**
 * Reads connect_ticket from the address bar and removes it at once, so the
 * ticket does not stay in history, bookmarks or shared links.
 */
export function takeConnectTicket(win: Window = window): string | null {
  const url = new URL(win.location.href);
  if (!url.searchParams.has(PARAM)) return null;
  const ticket = url.searchParams.get(PARAM);
  url.searchParams.delete(PARAM);
  // Keep the router's history state; only the address changes.
  win.history.replaceState(win.history.state, '', url.pathname + url.search + url.hash);
  return ticket || null;
}

export type ConnectTicketResult = 'none' | 'connected' | 'failed';

/**
 * Takes the ticket off the address bar and posts it to our backend.
 * 'none' when the page was opened without a ticket.
 */
export async function completeConnectFromUrl(
  post: (ticket: string) => Promise<unknown>,
  win: Window = window,
): Promise<ConnectTicketResult> {
  const ticket = takeConnectTicket(win);
  if (!ticket) return 'none';
  try {
    await post(ticket);
    return 'connected';
  } catch {
    return 'failed';
  }
}
